export const GROUPS = '/groups'
export const GROUPING = `${GROUPS}/create`
export const GROUP_ASSIGN = `${GROUPS}/assign`
